<template>
    <div class="top-tip">
        <svg-icon name="common.tip-solid" style="color:#266EFF;font-size:16px" />
        <slot v-if="$slots.default" />
        <template v-else>
            {{ text }}
        </template>
    </div>
</template>
<script>
export default {
    name: 'TopTip',
    props: {
        text: String,
    },
}
</script>
<style lang="less" scoped>
.top-tip {
    display: flex;
    font-size: 12px;
    line-height: 20px;
    padding: 6px 14px;
    color: #666666;
    align-items: center;
    background: rgba(38, 110, 255, 0.1);
    .svg-icon {
        flex-shrink: 0;
        margin-top: 2px;
        margin-right: 10px;
        align-self: flex-start;
    }
    .hc-link {
        font-size: 12px;
        color: #266eff;
    }
}
</style>
